import { render, staticRenderFns } from "./IncrementalOnboardingAddBeneficiary.vue?vue&type=template&id=920da242&"
import script from "./IncrementalOnboardingAddBeneficiary.vue?vue&type=script&lang=js&"
export * from "./IncrementalOnboardingAddBeneficiary.vue?vue&type=script&lang=js&"
import style0 from "./IncrementalOnboardingAddBeneficiary.vue?vue&type=style&index=0&id=920da242&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports